import { render, staticRenderFns } from "./recalificare.vue?vue&type=template&id=77634052"
import script from "./recalificare.vue?vue&type=script&lang=js"
export * from "./recalificare.vue?vue&type=script&lang=js"
import style0 from "./recalificare.vue?vue&type=style&index=0&id=77634052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports